import React from 'react';
import {
  Form,
  Textarea,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Button,
  CondensedMedium,
  DateUtil,
  Gutter,
} from '@axiom/ui';
import type { FullCandidateAccount } from '@axiom/validation';

import type { MyBenchCardHighlightsModalType } from './my-bench-card-highlights-modal-schema';
import { MyBenchCardHighlightsModalSchema } from './my-bench-card-highlights-modal-schema';

export type MyBenchEditHighlightsModalProps = {
  candidate: FullCandidateAccount;
  onClose: () => void;
  onSubmit: (arg: MyBenchCardHighlightsModalType) => void;
};

export const MyBenchCardHighlightsModal = ({
  candidate,
  onClose,
  onSubmit,
}: MyBenchEditHighlightsModalProps) => {
  const handleOnSubmit = (formData: MyBenchCardHighlightsModalType) => {
    onSubmit(formData);
  };

  return (
    <Form
      name="EDIT_HIGHLIGHTS_FORM"
      schema={MyBenchCardHighlightsModalSchema}
      initialValues={{ notes: candidate.calculatedNotes ?? '' }}
      onSubmit={(formData: Partial<MyBenchCardHighlightsModalType>) => {
        handleOnSubmit(formData as MyBenchCardHighlightsModalType);
      }}
    >
      {({ fireSubmit }) => {
        return (
          <Modal name="DIGITAL_BENCH_EDIT_HIGHLIGHTS">
            <ModalHeader
              name="MODAL_HEADER"
              onClose={() => {
                onClose();
              }}
            >
              Edit {candidate.calculatedDisplayName} bench highlights
            </ModalHeader>
            <ModalSection>
              <Gutter bottom="16px">
                <Textarea
                  name="notes"
                  label="Bench Highlights"
                  formatting="modern"
                  full
                />
              </Gutter>
              <CondensedMedium
                name="UPDATED_AT_BY"
                className="text-align-right"
              >
                {candidate.notesUpdatedAt
                  ? `Last edited by ${candidate.notesUpdatedByUser?.fullName ?? 'Axiom user'} on ${DateUtil.displayDateFullYearShortMonth(candidate.notesUpdatedAt)}`
                  : 'Profile Default'}
              </CondensedMedium>
            </ModalSection>
            <ModalFooter>
              <Button
                name="CANCEL"
                variation="outline"
                onClick={() => {
                  onClose();
                }}
              >
                Cancel
              </Button>
              <Button
                name="SUBMIT"
                type="submit"
                onClick={() => {
                  void fireSubmit();
                }}
              >
                Submit
              </Button>
            </ModalFooter>
          </Modal>
        );
      }}
    </Form>
  );
};
